import { Component } from 'react';
import { FormikProps, connect } from 'formik';

import { SalesOrder } from '../models/salesOrder';

interface SalesOrderDetailCtaHelperProps {
    onChange: (canComplete: boolean) => void;
}

type HelperProps = SalesOrderDetailCtaHelperProps & { formik: FormikProps<SalesOrder> };

class SalesOrderDetailCtaHelperBase extends Component<HelperProps> {
    private onChange = (values: SalesOrder) => {
        const enabled = values.positions.length > 0 && !!values.customerAccount;
        if (this.props.onChange) {
            this.props.onChange(enabled);
        }
    };

    public componentDidMount() {
        this.onChange(this.props.formik.values);
    }

    public UNSAFE_componentWillReceiveProps(nextProps: HelperProps) {
        const nextValues = nextProps.formik.values;
        const values = this.props.formik.values;
        if (
            nextValues.customerAccount !== values.customerAccount ||
            nextValues.positions.length !== values.positions.length
        ) {
            this.onChange(nextValues);
        }
    }

    public render() {
        return null;
    }
}

// Formik-Connect
export const SalesOrderDetailCtaHelper = connect<SalesOrderDetailCtaHelperProps, SalesOrder>(
    SalesOrderDetailCtaHelperBase
);
